const T_PREFIX = "deals";

export const noDealsBannerTrns = {
  title: `${T_PREFIX}.no-deals-banner.title`,
  description: `${T_PREFIX}.no-deals-banner.description`,
  addStartDealButton: `${T_PREFIX}.no-deals-banner.add-start-deal-btn`,
};

export const dealsTrns = {
  chatButton: `${T_PREFIX}.chat-btn`,
};
